import { render, staticRenderFns } from "./product-module.vue?vue&type=template&id=0305429f&scoped=true&"
import script from "./product-module.vue?vue&type=script&setup=true&lang=js&"
export * from "./product-module.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./product-module.vue?vue&type=style&index=0&id=0305429f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0305429f",
  null
  
)

export default component.exports